{
  "states": {
    "loading": "جارٍ التحميل...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "سان فرانسيسكو"
  },
  "conditions": {
    "Clear": "صافٍ",
    "Clouds": "غائم",
    "Rain": "مطر",
    "Drizzle": "رذاذ",
    "Thunderstorm": "عاصفة رعدية",
    "Snow": "ثلج",
    "Mist": "ضباب خفيف",
    "Smoke": "دخان",
    "Haze": "سديم",
    "Dust": "غبار",
    "Fog": "ضباب",
    "Sand": "رمال",
    "Ash": "رماد",
    "Squall": "عاصفة مفاجئة",
    "Tornado": "إعصار"
  },
  "modal": {
    "defaultTitle": "الطقس",
    "subtitle": "الأحوال الحالية",
    "showFahrenheit_aria": "عرض بالفهرنهايت",
    "showCelsius_aria": "عرض بالمئوية",
    "switchToCelsius_title": "التبديل إلى °C",
    "switchToFahrenheit_title": "التبديل إلى °F",
    "feelsLike": "الإحساس بـ {{temp}}°{{unit}}",
    "humidityWind": "الرطوبة {{humidity}}% · الرياح {{wind}}",
    "windSpeed": "{{speed}} ميل/س",
    "hourlyNow": "الآن",
    "hourlyOffset": "{{hours}} س",
    "hourlyStrip_aria": "درجة الحرارة بالساعة",
    "hourlyLocked": "التوقّعات بالساعة ميزة في Pro.",
    "statsLocked": "تفاصيل الطقس ميزة في Pro.",
    "stats": {
      "sunrise": "الشروق",
      "sunset": "الغروب",
      "feels": "الإحساس",
      "humidity": "الرطوبة",
      "wind": "الرياح",
      "rain": "المطر"
    },
    "rainInches": "{{value}} بوصة",
    "forecastTitle": "توقّعات 5 أيام",
    "forecastLoading": "جارٍ تحميل التوقّعات…",
    "forecastUnavailable": "التوقّعات غير متاحة",
    "forecastLocked": "توقّعات 5 أيام ميزة في Pro.",
    "forecastRow_aria": "توقّعات خمسة أيام",
    "proHeadline": "التوقعات الكاملة جزء من Pro.",
    "proFeatures": "كل ساعة · تفاصيل الأحوال · توقعات ٥ أيام."
  }
}
